import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../hooks";
import { useState } from "react";
import { BasicSelector } from "../ui";
import { setLang } from "../../store/langSlice";
import axios from "axios";

const UserBar = ({ tenantUsername, tenantImage, tenant }) => {
  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getUser } = useUser();
  const _token = localStorage.getItem("token");

  const [openListLang, setOpenListLang] = useState(false);
  const langSelected = useSelector((state) => state.lang);
  const user = useSelector((state) => state.auth).user;
  const currentCompany = useSelector((state) => state.currentCompany);
  const currentBranch = useSelector((state) => state.currentBranch);

  const listLangHandler =
    tenant?.languages?.map((language) => ({
      label:
        language.langCode === "ar"
          ? "عربي"
          : language.langCode === "en"
            ? "English"
            : language.langName || language.langCode,
      value: language.langCode,
    })) || [];

  const logoutHandler = () => {
    navigate(`/${tenantUsername}/logout`);
  };

  const onSelectedUserList = (item) => {
    if (item.value === "Logout") logoutHandler();
  };

  const [openListUser, setOpenListUser] = useState(false);
  const userList = [
    { label: "My Account", value: "MyAccount" },
    { label: "Change Password", value: "ChangePassword" },
    { label: "Logout", value: "Logout" },
  ];
  const saveCentralSelection = async (
    selectedCompanyId,
    selectedBranchId,
    selectedLang,
  ) => {
    if (!user?.tenant_id) return;
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      await axios.put(
        `${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`,
        {
          tenantId: user.tenant_id,
          scope: "header-selection",
          data: {
            selectedCompanyId,
            selectedBranchId,
            selectedLang,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
          validateStatus: () => true,
        },
      );
    } catch (error) {}
  };
  const onSelectedLangHandler = (lang) => {
    i18n.changeLanguage(lang.value);
    dispatch(setLang({ label: lang.label, value: lang.value }));
    saveCentralSelection(
      currentCompany?.value || user?.company_id,
      currentBranch?.value || user?.branch_id,
      lang.value,
    );
  };

  return (
    <div className="flex text-white flex-wrap items-center justify-between gap-2 text-xs md:justify-end md:me-[-21px] w-full px-2">
      <BasicSelector
        border={false}
        listItem={userList}
        label={getUser?.name}
        defaultValue={getUser?.name}
        openList={openListUser}
        setOpenList={setOpenListUser}
        withChangeLabel={false}
        onSelected={onSelectedUserList}
      >
        {tenantImage ? (
          <img className="w-5 me-3 h-5" src={tenantImage} alt="User Avatar" />
        ) : (
          <img
            className="w-5 me-1 h-5 "
            src="/icons/avatar-3637425_640.png"
            alt="User Avatar"
          />
        )}
      </BasicSelector>

      <img
        className="w-4 hover:w-[18.5px]  cursor-pointer transition-[0.7s]"
        src="/icons/notification.png"
        alt="Notifications"
      />

      <Link
        className="px-1"
        target="_blank"
        to={`https://support.absat-erp.com/${tenantUsername}/token/${_token}`}
      >
        <img
          className="w-5 hover:w-[21.5px] transition-[0.7s]"
          src="/icons/(4).png"
          alt="Help"
        />
      </Link>

      {/* رابط الإعدادات */}
      {/* <Link className="px-1" to={`:tenant/settings`}>
          <img className="w-5 hover:w-[21.5px] transition-[0.7s]" src="/icons/settings.png" alt="Settings" />
        </Link> */}

      <BasicSelector
        border={false}
        label={langSelected.label}
        openList={openListLang}
        setOpenList={setOpenListLang}
        onSelected={onSelectedLangHandler}
        defaultValue={langSelected.value}
        listItem={listLangHandler}
      >
        <img className="w-4 me-2 " src="/icons/(18).png" alt="Language" />
      </BasicSelector>
    </div>
  );
};

export default UserBar;
